<template>
  <div
    style="
      background-color: rgba(52, 152, 219, 0.97);
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <span class="big-font">请在手机端打开</span>
  </div>
</template>

<script>
export default {
  name: 'Tip',
}
</script>

<style scoped></style>
